<template>

  <!-- app-layer {admin} -->
  <div class="app-layer admin" @click="layerClick($event)">

    <transition name="right-modal" v-show="show">

      <div class="modal-custom right" name="sync-rows" v-if="show" :class="{loading: loading}">

        <span class="close" @click="closeModal()">chiudi</span>

        <div class="content">
          <h1 class="mt-0">Gestione righe aggiornamento #{{sync.id}}</h1>
          <p class="subdesc">Richiesto da: <span class="bold">{{sync.username}}</span></p>
          <div v-if="sync.description != null && sync.description != ''">
            <h3 class="m-0">Descrizione</h3>
            <div class="description_sync">{{sync.description}}</div>
          </div>

          <div class="sync-rows mb-1">

            <ul v-if="sync && sync.rows.length > 0" class="elements-list">

              <li class="element" v-for="(row, i) in sync.rows" :key="row.updating_id+'-'+row.index_running">

                <h3>{{row.index_running}}) {{trans.get('sync.models_sync.'+row.model)}}</h3>

                <section class="status single-sync-row">
                  <label>Stato</label>
                  <span v-if="row.status === 1" class="bold successeful">successo</span>
                  <span v-else-if="row.status === 0" class="bold failed">fallito</span>
                  <span v-else-if="row.status === null" class="bold">in corso</span>
                </section>

                <section class="status">
                  <label>Info</label>
                  <span v-if="row.info !== null" class="">{{row.info}}</span>
                  <span v-else class="bold successeful">nulla da aggiornare</span>
                </section>

                <section class="datetime">
                  <label>
                    <span class="mr-1">Inizio - Fine</span> <span><img class="icon" :src="iconTimeStart(row)" alt="icon day time"></span>
                  </label>
                  <span class="date">{{row.date_start}}</span><br>
                  <span class="date" v-show="row.status !== null">{{row.date_end}}</span>
                </section>

                <section class="timestamp">
                  <label>
                    <span class="mr-1">Timestamp inviato</span></span>
                  </label>
                  <span class="date">{{row.timestamp_sent}}</span>
                </section>

                <section class="datetime timestamp">
                  <label>
                    <span class="mr-1">Timestamp programmato</span>
                    <span>
                      <span class="date mr-1" v-if="row.timestamp_scheduled">{{row.timestamp_scheduled}}</span>
                      <span class="date mr-1" v-else>nessuno</span>
                      <span class="load-component" @click="timestampScheduled(row, 'add')">modifica</span>
                    </span>
                  </label>


                  <span v-if="timestampScheduled(row, 'isset')">
                    <input type="text" placeholder=" yyyy-mm-dd hh:mm:ss" v-model="timestamp_scheduled[row.index_running]">
                    <button @click="updateTimestampScheduled(row)" class="belt-btn-small">aggiorna timestamp</button>
                  </span>
                </section>

              </li>

            </ul>

            <p v-else class="empty">Questo aggiornamneto non presenta ancora nessuna riga</p>

          </div>
        </div>

      </div>

    </transition>

  </div>

</template>

<script>

export default{


  props: {
    sync: {type: Object},
  },

  data: function(){

    return {

      loading: false,
      show: false,
      // ... modal data

      timestamp_scheduled: {},

    }

  },

  computed: {

    credential_email: function(){

      // return this.default_email ? indirizzo.email :

    },

  },

  methods: {

    layerClick: function(event){

      if( event.target.classList.contains('app-layer') ) this.closeModal();

    },

    // manage close animation
    closeModal: function(){

      this.show = false;
      setTimeout(function(vue){
        vue.$destroy();
      }, 400, this);

    },

    iconTimeStart: function(row) {
      let hour = new Date(row.date_start).getHours();
      return hour > 6 && hour < 18 ? this.url('/media/icons/svg/sun.svg') : this.url('/media/icons/svg/night.svg');
    },

    timestampDefault: function (timestamp) {
      return ['', null].indexOf(timestamp) > 0 || isNaN(new Date(timestamp).getTime()) ? '1800-01-01 00:00:00' : timestamp;
    },

    timestampScheduled: function(row, action) {
      switch (action) {
        case 'isset':
        return row.index_running in this.timestamp_scheduled;
        break;
        case 'add':
        this.$set(this.timestamp_scheduled, row.index_running, this.timestampDefault(row.timestamp_scheduled) );
        break;

        // case 'update':
        // this.$set(this.timestamp_scheduled, row.index_running, row.timestamp_scheduled);
        // break;

        case 'delete':
        this.$delete(this.timestamp_scheduled, row.index_running);
        break;
      }
    },

    updateTimestampScheduled: function(row) {

      var newTimeStamp = this.timestamp_scheduled[row.index_running].trim();
      if(newTimeStamp === '') newTimeStamp = null;

      if(newTimeStamp !== null && (!this.is_timestamp(newTimeStamp) || isNaN(new Date(newTimeStamp).getTime())) ) {
        this.$store.commit('add_message', {
          type: 'info',
          message: 'Inserire un timestamp corretto: YYYY-MM-DD HH:MM:SS'
        });
        return;
      }

      var vue = this;
      vue.loading = true;

      axios({
        method: "post",
        url: window.location.origin + '/data/updating-sync/update-timestamp-scheduled',
        params: {
          json: JSON.stringify({
                  updating_row: {
                    updating_id: row.updating_id,
                    index_running: row.index_running,
                    model: row.model,
                  },
                  new_timestamp_sheduled: newTimeStamp,
                }),
        }
      })
      .then(res => {

        vue.$store.commit('add_message', {
          type: 'success',
          message: res.data.message
        });

        vue.timestampScheduled(row, 'delete');
        row.timestamp_scheduled = newTimeStamp;

      })
      .catch(err => {

        console.log(err.response.data);
        vue.$store.commit('add_message', {
          type: 'error',
          message: err.response.data.message,
          autoclose: false
        });

      })
      .then(() =>{
        vue.loading = false;
      })

    },

    is_timestamp: function (pattern) {
      var regex = /^([0-9]{4}-([0]?[1-9]|1[0-2])-([0]?[1-9]|[1-2][0-9]|3[0-1])( (0?[0-9]|1[0-9]|2[0-3]):(0?[0-9]|[1-5][0-9])(:0?([0-9]|[1-5][0-9]))?)?)$/;
      return regex.test(pattern);
    }


  },

  mounted: function(){

    // show component
    this.show = true;

  },

  // send modal destry to other components
  destroyed: function(){

    this.$parent.manage_sync_rows = false;

  }

}
</script>

<style scoped>
.modal-custom{
  background-color: white;
  max-width: 800px;
  padding: 20px;
  height: 100vh;
  overflow-y: auto;
}
ul.elements-list{
  margin: 0;
  padding: 0;
  list-style-type: none;
}
ul.elements-list li{
  width: 100%;
}
div.new-elements{
  margin: 2em 0;
}
ul.elements-list li {
  border-bottom: 1px solid black;
}
ul.elements-list li section.status span.failed{
  color: var(--red);
}
ul.elements-list li section.status span.successeful{
  color: var(--blue);
}
ul.elements-list li section.datetime label {
  display: flex;
  align-items: center;
}
ul.elements-list li section.datetime label img.icon{
  width: 20px;
}
.description_sync {
  width: 100%;
  height: auto;
  padding: 1em;
  color: var(--checkbox-gray);
  border: 1px solid var(--disabled);
}
p.subdesc, span.subdesc {
	margin-top: 0;
	color: var(--checkbox-gray);
}
</style>
